<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <!-- ===== SEARCH FORM ===== -->
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Search Form
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-form ref="bonusProcessForm" @submit.prevent="submit">
                  <v-row class="mt-4">

                    <!-- Employee -->
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="employee_id.value.value"
                        :error-messages="employee_id.errorMessage.value"
                        variant="outlined"
                        label="Employee"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :loading="loading"
                        :items="getHrmEmployeeList"
                        item-title="name"
                        item-value="id"
                        prepend-inner-icon="mdi-account"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <!-- Department -->
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="department_id.value.value"
                        :error-messages="department_id.errorMessage.value"
                        variant="outlined"
                        label="Department"
                        density="compact"
                        bg-color="grey-lighten-4"
                        :loading="loading"
                        :items="getHrmDepartmentList"
                        item-title="name"
                        item-value="id"
                        prepend-inner-icon="mdi-office-building"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <!-- Year -->
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="year.value.value"
                        :error-messages="year.errorMessage.value"
                        :items="years"
                        item-title="label"
                        item-value="value"
                        variant="outlined"
                        label="Year"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-calendar-month"
                        clearable
                        @scroll.passive="onYearScroll"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Month -->
                    <v-col cols="12" md="3">
                      <v-autocomplete
                        v-model="month.value.value"
                        :error-messages="month.errorMessage.value"
                        :items="getMonthList"
                        item-title="label"
                        item-value="value"
                        variant="outlined"
                        label="Month"
                        density="compact"
                        bg-color="grey-lighten-4"
                        prepend-inner-icon="mdi-calendar-month"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                  </v-row>

                  <v-card-actions class="justify-end pa-2">
                    <v-btn
                      color="primary"
                      variant="flat"
                      type="submit"
                      size="small"
                      :loading="loading"
                    >
                      Search
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

          <!-- ===== BONUS PROCESS LIST ===== -->
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Bonus Process List
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-data-table
                  :headers="tableHeaders"
                  :items="getEmployeeBonusList"
                  :loading="loading"
                  class="mt-6"
                  density="comfortable"
                  hover
                >
                  <template #item.index="{ index }">
                    {{ index + 1 }}
                  </template>
                  
                  <template #item.employee_name="{ item }">
                    {{ item.employee?.name ?? '-' }}
                  </template>

                  <template #item.department_name="{ item }">
                    {{ item.department?.name ?? '-' }}
                  </template>

                  <template #item.bonus_type="{ item }">
                    {{ item.bonus_process_master?.bonus_type?.name ?? '-' }}
                  </template>

                  <template #item.code="{ item }">
                    {{ item.bonus_process_master?.code ?? '-' }}
                  </template>

                  <template #item.process_date="{ item }">
                    {{ item.bonus_process_master?.process_date ?? '-' }}
                  </template>

                  <template #item.year="{ item }">
                    {{ item.bonus_process_master?.year ?? '-' }}
                  </template>

                  <template #item.month="{ item }">
                    {{ getMonthList.find(m => m.value == item.bonus_process_master?.month)?.label ?? '-' }}
                  </template>

                  <template #item.total_payable="{ item }">
                    {{ item.bonus_process_master?.total_payable ?? 0 }}
                  </template>

                  <template #item.action="{ item }">
                    <v-btn @click="employeeBonusDetails(item.id)" color="primary" variant="flat" type="submit" size="small" :loading="loading">
                      Details
                    </v-btn>
                  </template>
                </v-data-table>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>

        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";

export default {
  setup() {
    const store = useStore();
    const loading = ref(false);
    const panel = ref([0]);
    const panel1 = ref([0]);

    const employee_id = useField("employee_id");
    const department_id = useField("department_id");
    const year = useField("year");
    const month = useField("month");

    const { handleSubmit } = useForm({
      validationSchema: yup.object({}),
    });

    // Year lazy load
    const startYear = ref(new Date().getFullYear() - 5);
    const endYear = ref(new Date().getFullYear() + 5);
    const years = ref([]);
    const generateYears = (start, end) => {
      for (let i = start; i <= end; i++) {
        if (!years.value.find(y => y.value === i)) {
          years.value.push({ label: i.toString(), value: i });
        }
      }
    };
    generateYears(startYear.value, endYear.value);

    const onYearScroll = (event) => {
      const container = event.target;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 5) {
        // Load next 5 years
        startYear.value = endYear.value + 1;
        endYear.value += 5;
        generateYears(startYear.value, endYear.value);
      }
    };

    const submit = handleSubmit((values) => {
      loading.value = true;
      const payload = {
        department_id: department_id.value.value,
        employee_id: employee_id.value.value,
        year: year.value.value,
        month: month.value.value,
      };

      store
        .dispatch("getEmployeeBonusList", payload)
        .catch((err) => {
          toast.error(err.response?.data?.message || "Something went wrong");
        })
        .finally(() => {
          loading.value = false;
        });
    });

    return {
      panel,
      panel1,
      loading,
      employee_id,
      department_id,
      year,
      month,
      years,
      onYearScroll,
      submit,
    };
  },

  methods: {
    employeeBonusDetails(id){
      this.$router.push({
        name: "employee-bonus-details-view",
        params: { id }
      });
    }
  },

  computed: {
    getHrmEmployeeList() {
      return this.$store.getters.getHrmEmployeeList;
    },
    getHrmDepartmentList() {
      return this.$store.getters.getHrmDepartmentList || [];
    },
    getEmployeeBonusList() {
      return this.$store.getters.getEmployeeBonusList || [];
    },
    getMonthList() {
      return [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" },
      ];
    },
    tableHeaders() {
      return [
        { title: "#", key: "index", sortable: false },
        { title: "Employee", key: "employee_name" },
        { title: "Department", key: "department_name" },
        { title: "Bonus Type", key: "bonus_type" },
        { title: "Code", key: "code" },
        { title: "Process Date", key: "process_date" },
        { title: "Year", key: "year" },
        { title: "Month", key: "month" },
        { title: "Total Payable", key: "total_payable" },
        { title: "Action", key: "action" },
      ];
    },
  },

  created() {
    if (this.$store.getters.getHrmEmployeeList.length === 0) this.$store.dispatch("getHrmEmployeeList");
    if (this.$store.getters.getHrmDepartmentList.length === 0) this.$store.dispatch("getHrmDepartmentList");
    if (this.$store.getters.getEmployeeBonusList.length === 0) this.$store.dispatch("getEmployeeBonusList");
  },
};
</script>

<style scoped></style>
